import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import StringElementDetails from './StringElementDetails';
import MultipleChoiceElementDetails from './MultipleChoiceElementDetails';
import AttachmentElementDetails from './AttachmentElementDetails';

import './formElementDetails.css';

class FormElementDetails extends PureComponent {
  handleFormElementRemove = () => {
    const {
      selectedElement,
      onFormElementRemove
    } = this.props;

    const { id } = selectedElement;

    onFormElementRemove(id);
  };

  render() {
    const {
      selectedElement,
      onFormElementChange,
      onFormElementTypeChange,
      onMoveUp,
      onMoveDown,
      onFormElementCloseEditor,
      onFormElementRequiredChange,
      onFormElementOptionsChange
    } = this.props;

    const { type, format } = selectedElement;

    let details;

    switch (type) {
      case 'string':
      case 'integer':
      {
        // It's a select component with string items.
        if (_.has(selectedElement, 'enum')) {
          details = (
            <MultipleChoiceElementDetails
              element={selectedElement}
              onFormElementChange={onFormElementChange}
              onFormElementTypeChange={onFormElementTypeChange}
              onFormElementRequiredChange={onFormElementRequiredChange}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              onFormElementOptionsChange={onFormElementOptionsChange}
            />
          );
          break;
        }

        // It's a single file select component
        if (format === 'data-url') {
          details = (
            <AttachmentElementDetails
              element={selectedElement}
              onFormElementChange={onFormElementChange}
              onFormElementTypeChange={onFormElementTypeChange}
              onFormElementRequiredChange={onFormElementRequiredChange}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
            />
          );
        }
        // It's one of text/parapgraph/number/date (the string element details will know)
        else {
          details = (
            <StringElementDetails
              element={selectedElement}
              onFormElementChange={onFormElementChange}
              onFormElementTypeChange={onFormElementTypeChange}
              onFormElementRequiredChange={onFormElementRequiredChange}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
            />
          );
        }
        break;
      }

      // It's a checkbox based multiple choice
      case 'array':
      {
        // It's a multiple file select component
        if (format === 'data-url') {
          details = (
            <AttachmentElementDetails
              element={selectedElement}
              onFormElementChange={onFormElementChange}
              onFormElementTypeChange={onFormElementTypeChange}
              onFormElementRequiredChange={onFormElementRequiredChange}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
            />
          );
        }
        else {
          details = (
            <MultipleChoiceElementDetails
              element={selectedElement}
              onFormElementChange={onFormElementChange}
              onFormElementTypeChange={onFormElementTypeChange}
              onFormElementRequiredChange={onFormElementRequiredChange}
              onMoveUp={onMoveUp}
              onMoveDown={onMoveDown}
              onFormElementOptionsChange={onFormElementOptionsChange}
            />
          );
        }
        break;
      }

      default:
        break;
    }

    return (
      <div className="element-details-container">
        <h2>
          Question properties
          <i
            className="glyphicon glyphicon-remove close"
            role="button"
            aria-hidden="true"
            onClick={onFormElementCloseEditor}
          />
        </h2>
        {details}
        <button type="button" onClick={this.handleFormElementRemove} className="btn btn-link remove">
          <i className="glyphicon glyphicon-trash" />
          Remove question
        </button>
      </div>
    );
  }
}

FormElementDetails.propTypes = {
  selectedElement: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string,
    format: PropTypes.string
  }).isRequired,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementTypeChange: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  onFormElementRemove: PropTypes.func.isRequired,
  onFormElementCloseEditor: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onFormElementOptionsChange: PropTypes.func.isRequired
};

export default FormElementDetails;
